"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _phLoading = _interopRequireDefault(require("./ph-loading.gif"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var style = {
  textAlign: 'enter',
  display: 'block',
  width: 130,
  height: 130,
  marginLeft: '-65px',
  marginTop: '-65px',
  position: 'absolute',
  top: '50%',
  left: '50%'
};

var LoadingComponent = function LoadingComponent(_ref) {
  var _ref$absolute = _ref.absolute,
      absolute = _ref$absolute === void 0 ? true : _ref$absolute;
  return /*#__PURE__*/_react["default"].createElement("img", {
    src: _phLoading["default"],
    alt: "loading",
    "data-loader": true,
    style: absolute ? style : _objectSpread(_objectSpread({}, style), {}, {
      position: 'relative'
    })
  });
};

LoadingComponent.propTypes = {
  "absolute": _propTypes["default"].bool
};
var _default = LoadingComponent;
exports["default"] = _default;
//# sourceMappingURL=LoadingComponent.js.map